module.exports = __webpack_public_path__ + "static/media/sprite.mp3.2bc85bc.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite.mp3.ogg
// module id = qNnC
// module chunks = 1